var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonajeDudaM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 263.02,
    height: 288,
    viewBox: "0 0 263.02 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PersonajeDudaM",
    transform: "translate(4304.122 -89.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    fill: "#1c1a24",
    d: "M-4068.219,227.722c.954-23.249,1.293-46.827-3.985-69.49s-17.228-44.7-36.818-57.261C-4123.76,91.52-4141.9,88.1-4159.338,89.64s-34.222,7.829-49.454,16.46l-1.474-.27c-13.525-5.787-29.795,1.04-39.391,12.19s-14.035,25.711-18.229,39.811q-16.693,56.126-33.388,112.249c-2.026,6.813-4.059,14.112-1.971,20.907,2.175,7.077,8.5,12.191,15.279,15.163a45.262,45.262,0,0,0,33.183,1.094,45.245,45.245,0,0,0,24.8-22.069c.311,20.6,29.662,38.52,49.866,7.643,0,0,16.013,50.32,46.128,1.906,0,0,34.69,62.137,58.706,7.624C-4070.326,266.9-4068.989,246.447-4068.219,227.722Z",
    "data-name": "Path 55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    fill: "none",
    stroke: "#1c1a24",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M-4176.6,246.421",
    "data-name": "Path 56",
    transform: "translate(15.278 18.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    fill: "#ff4527",
    d: "M-4070.025,227.94h-15.155a84.555,84.555,0,0,0,.623-10.078,83.985,83.985,0,0,0-86.01-83.961c-38.853.914-71.449,28.667-79.852,65.3a32.4,32.4,0,0,0-9.237-.087,31.989,31.989,0,0,0-27.43,28.418,31.921,31.921,0,0,0,31.758,35.122,31.792,31.792,0,0,0,13.852-3.154,83.941,83.941,0,0,0,72.934,42.348h78.413a47,47,0,0,0,47-47.005h0A26.9,26.9,0,0,0-4070.025,227.94Z",
    "data-name": "Path 57",
    transform: "translate(2.023 5.343)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    cx: 22.009,
    cy: 22.009,
    r: 22.009,
    fill: "#e4e3c2",
    "data-name": "Ellipse 16",
    transform: "translate(-4205.838 242.51)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(-4197.695 185.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    fill: "#1c1a24",
    d: "M-4205.168,197.654a3.89,3.89,0,0,1-2.187-.672,3.912,3.912,0,0,1-1.061-5.425c5.137-7.651,20.252-20.517,40.681-14.438a3.921,3.921,0,0,1,2.64,4.875,3.919,3.919,0,0,1-4.875,2.638c-19.929-5.927-31.463,10.6-31.945,11.306A3.931,3.931,0,0,1-4205.168,197.654Z",
    "data-name": "Path 58",
    transform: "translate(4209.082 -175.537)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(-4125.576 191.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    fill: "#1c1a24",
    d: "M-4123.621,194.368c-10.567,0-19.008-6.151-19.475-6.5a3.917,3.917,0,0,1-.81-5.483,3.917,3.917,0,0,1,5.474-.816c.148.109,11.688,8.4,22.476,3.238a3.918,3.918,0,0,1,5.227,1.844,3.919,3.919,0,0,1-1.845,5.227A25.345,25.345,0,0,1-4123.621,194.368Z",
    "data-name": "Path 59",
    transform: "translate(4144.679 -180.804)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    fill: "#1c1a24",
    d: "M-4084.2,173.924c.735,5.753-4.187,11.256-9.9,12.268s-20.374,5.475-29.2-2.464c-10.864-9.769-1.428-25.589-20.87-38.741-8.472-5.731-31.971-7.748-40.068-1.5l-.426.469a168.991,168.991,0,0,1-18.357,48.391c-1.971,3.464-4.133,6.939-7.282,9.376s-7.52,3.668-11.208,2.162-6-6.292-4.044-9.766a292.859,292.859,0,0,1-19.127,49.485,17.867,17.867,0,0,1-3.715,5.558,6.33,6.33,0,0,1-6.2,1.592c-3.415-1.254-4.148-5.688-4.233-9.326a198.533,198.533,0,0,1,3.671-42.865l13.492-54.437s18.869-32.593,82.057-28.019S-4084.2,173.924-4084.2,173.924Z",
    "data-name": "Path 60",
    transform: "translate(5.42 3.161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    fill: "#1c1a24",
    d: "M-4184.221,195.069a7.435,7.435,0,0,0-5.058,2.015l-3.894-1.7a1.839,1.839,0,0,0-1.295-.169,1.717,1.717,0,0,0-1,.772,1.706,1.706,0,0,0-.17,1.294,1.635,1.635,0,0,0,.774,1l3.7,1.611c-.049.127-.1.252-.139.382l-5.115-.752a1.727,1.727,0,0,0-2.068,1.174,1.7,1.7,0,0,0,1.174,2.066l6.063.891c2.383,2.991,14.559,2.577,14.543-1.149A7.473,7.473,0,0,0-4184.221,195.069Z",
    "data-name": "Path 61",
    transform: "translate(12.651 12.674)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    fill: "#1c1a24",
    d: "M-4110.333,199.79a1.716,1.716,0,0,0-2.068-1.172l-4.6,1.118c-.018-.043-.031-.087-.05-.129l2.624-1.487a1.7,1.7,0,0,0,.6-2.3,1.714,1.714,0,0,0-2.3-.6l-2.937,1.665a7.447,7.447,0,0,0-4.895-1.805,7.47,7.47,0,0,0-7.44,7.506c.017,3.929,13.554,4.057,14.84.5l5.05-1.227A1.7,1.7,0,0,0-4110.333,199.79Z",
    "data-name": "Path 62",
    transform: "translate(20.694 12.665)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(-4143.516 247.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    fill: "#1c1a24",
    d: "M-4158.2,240.946a52.65,52.65,0,0,1,38.211-6.079c2.1.475,3-2.763.893-3.238a56.171,56.171,0,0,0-40.8,6.416,1.681,1.681,0,0,0,1.7,2.9Z",
    "data-name": "Path 63",
    transform: "translate(4160.7 -230.269)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(-4123.241 254.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    fill: "#1c1a24",
    d: "M-4140.46,242.058l7.243-1.716a1.694,1.694,0,0,0,1.173-2.066,1.717,1.717,0,0,0-2.065-1.174l-7.243,1.717a1.7,1.7,0,0,0-1.175,2.066,1.717,1.717,0,0,0,2.067,1.172Z",
    "data-name": "Path 64",
    transform: "translate(4142.594 -237.052)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(-4131.343 217.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    fill: "#1c1a24",
    d: "M-4149.752,206.321l3.981,11.063a1.723,1.723,0,0,0,2.066,1.174,1.694,1.694,0,0,0,1.173-2.066l-3.981-11.064a1.722,1.722,0,0,0-2.066-1.172,1.7,1.7,0,0,0-1.173,2.066Z",
    "data-name": "Path 65",
    transform: "translate(4149.829 -204.194)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    cx: 22.009,
    cy: 22.009,
    r: 22.009,
    fill: "#e4e3c2",
    "data-name": "Ellipse 17",
    transform: "translate(-4093.003 240.503)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    fill: "#1c1a24",
    d: "M-4083.669,303.018c-.98-4.71-3.89-9.262-8.061-13.123a25.771,25.771,0,0,0,1-10,13.682,13.682,0,0,0-7.884-10.833c5.08-6.853,11.015-14.242,13.006-18.28,2.415-4.9,3.145-10.678-1.012-13.794a7.389,7.389,0,0,0-5.457-1.271c-3.851.536-6.774,3.035-9.589,5.469-18.019,15.583-26.218,22.612-44.237,38.194,0,0-2.192-26.493-14.2-26.493-12.3,0-2.764,21.538-17.918,47.269q-.287.49-.57.97a38.829,38.829,0,0,0,10.6,51.208h0a38.841,38.841,0,0,0,46.42-.573l15.887-12.149C-4099.018,334.342-4079.7,322.059-4083.669,303.018Z",
    "data-name": "Path 66",
    transform: "translate(14.39 17.534)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonajeDudaM);
export default __webpack_public_path__ + "static/media/PersonajeDudaM.ed32795419e56bd89b3f1d6f81b5c04a.svg";
export { ForwardRef as ReactComponent };